import React from "react";
import ReactApexChart from "react-apexcharts";
import close from "../../minimise_button.png";
class CChart extends React.Component {
  constructor(props) {
    super(props);
  
 
}
  render() {
    let options= {
      chart: {
      //  id: "basic-bar",
        toolbar: {
          autoSelected: "pan",
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [
              {
                icon: `<img src=${close} width="20" height="20"> `,
                index: 0,
                title: "minimize",
                class: "custom-icon",
                click: this.props.toggleVisibleGraphPanel,
                
              },
            ],
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          //barHeight:"75%",
          dataLabels: {
            position: "top",
          },
        },
      },
      xaxis: {
        categories: this.props.categories,
        title: {
          text: this.props.xaxis,
        },
        labels: {
          rotateAlways: false,
          hideOverlappingLabels: false,
          rotate: 270,
          style: {
            // colors: ['#F44336'],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
        },
        },
        
      },
      yaxis: {
        title: {
          text: this.props.yaxis,
          style: {
            fontSize: "12px",
          },
        },
        labels: {
          formatter: function (val) {
            return val.toFixed();
          },
        },
        // label:{

        // }
      },
      tooltip: {
        y: {
          formatter: function (
            value,
            { series, seriesIndex, dataPointIndex, w }
          ) {
            // console.log(value,props.units)
            return (
              Number(value).toLocaleString("en-IN").valueOf()
            );
          },
        },
      },
      
      title: {
        text: this.props.title,
        align: "center",
        style: {
          fontSize: "16px",
          color: "#0000ff",
          fontSytle: "bold",
        },
        
      }

    };
    
    return (
      // <React.Fragment style={{backgroundColor:"white",height:"300px"}}>
      <ReactApexChart
        options={options}
        series={ [
          {
           name: "No. of Glacial Lakes",
           data: this.props.series,
          }, 
           ]}
        type="bar"
        className={this.props.classname} 

        height="100%"
        width="100%"

      />
      // </React.Fragment>
    );
  }
}

export default CChart;
